import { emptyString, groupsConstants, globalConstants } from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  GROUPS,
  GROUPS_DATA,
  GROUP_DETAIL,
  RESET_GROUPS,
  UPDATE_GROUP,
  GROUP_CREATED,
  GET_ALL_LOCATIONS,
  STORES_BY_GROUP_ID,
  PAGINATED_GROUPS_DATA,
  UPDATE_GROUP_RESPONSE,
  RESET_GROUPS_AGAINST_BRAND_ID,
} = groupsConstants;

const initialState = {
  allGroups: [],
  filteredGroups: [],
  groupDeleted: false,
  groupCreated: emptyString,
  groups: [],
  groupId: 0,
  groupDetails: [],
  allLocations: [],
  allGroupLocations: [],
  brandLocationDeleted: emptyString,
  collectiveData: {},
  groupUpdateResponse: emptyString,
  groupDataPagination: {
    size: 10,
    number: -1,
    totalElements: 0,
  },
};

export const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUPS_DATA + SUCCESS:
      return {
        ...state,
        allGroups: [...state.allGroups, ...(action?.data?.data || [])],
        filteredGroups: [],
        groupDeleted: false,
      };
    case PAGINATED_GROUPS_DATA + SUCCESS:
      return {
        ...state,
        allLocations: action.data.pageData,
        groupDataPagination: action.data.page,
        collectiveData: action.data.componentData,
      };
    case GROUP_DETAIL + SUCCESS:
      return { ...state, groupDetails: action.data };
    case GROUP_CREATED + SUCCESS:
      return { ...state, groupCreated: action.data?.data };
    case GROUPS + SUCCESS:
      return { ...state, groups: action.data };
    case RESET_GROUPS + SUCCESS:
      return {
        ...state,
        allGroups: [],
      };
    case GET_ALL_LOCATIONS + SUCCESS:
      return {
        ...state,
        allLocations: action.data.stores,
        groups: { data: action.data.groups },
      };
    case STORES_BY_GROUP_ID + SUCCESS:
      return {
        ...state,
        allGroupLocations: action.data?.data,
      };
    case STORES_BY_GROUP_ID + FAILURE:
      return {
        ...state,
        allGroupLocations: action.data,
      };
    case UPDATE_GROUP + SUCCESS:
      return {
        ...state,
        allGroups: action.data.data,
      };
    case UPDATE_GROUP + FAILURE:
    case UPDATE_GROUP_RESPONSE + SUCCESS:
      return {
        ...state,
        groupUpdateResponse: action.data,
      };
    case RESET_GROUPS_AGAINST_BRAND_ID + SUCCESS:
      return {
        ...state,
        groups: [],
      };
    default:
      return state;
  }
};
